import { render, staticRenderFns } from "./ManageWorkflows.vue?vue&type=template&id=39372a3a&scoped=true"
import script from "./ManageWorkflows.vue?vue&type=script&lang=js"
export * from "./ManageWorkflows.vue?vue&type=script&lang=js"
import style0 from "./ManageWorkflows.vue?vue&type=style&index=0&id=39372a3a&prod&lang=css"
import style1 from "./ManageWorkflows.vue?vue&type=style&index=1&id=39372a3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39372a3a",
  null
  
)

export default component.exports